<div class="question-view">
  <div class="header">
    <h1>{{benefitTitle}}</h1>
    <p *ngFor="let message of messages">{{message}}</p>
  </div>
    
  <app-button [text]="'Nächster Schritt'" (clickEvent)="handleNextClick()"></app-button>
</div>